import envelop from "./../../assets/img/envelop.png";
import lock from "./../../assets/img/lock.png";
import done from './../../assets/img/done.png'
const Icons = {
    envelop, 
    lock, 
    done
}

export default Icons